export default "__VITE_ASSET__CtC0edya__"